export default "__VITE_ASSET__9PTbIl$c__"